import {
  ActionReducer,
  ActionReducerMap,
  createFeatureSelector,
  createSelector,
  MetaReducer
} from '@ngrx/store';
import { environment } from '../../../environments/environment';
import * as AuthenticationReducer from '../authentication/authentication.reducer';

export interface State {
  user: AuthenticationReducer.State;
}

export const reducers: ActionReducerMap<State> = {
  user: AuthenticationReducer.reducer
};


export const metaReducers: MetaReducer<State>[] = !environment.production ? [] : [];
